define('webshopAttributesView',[
  'module',
  'app',
  'marionette',
  'underscore',
  'modalsAlertView',
  'webshopAttributesMatchingView',
  'webshopAttributesCategoryView',
  'webshopAttributesGridView',
  'webshopAttributesCategoryFiltersView',
  'entities/webshop/attribute_matching',
  'template!webshopAttributesView'
], function (
  Module,
  App,
  Marionette,
  _,
  AlertView,
  MatchingView,
  CategoryView,
  GridView,
  CategoryFiltersView,
  MatchingApi,
  Tpl
) {
  'use strict';

  // Webshop > Attributes: the attribute matching table (canonical attributes / values, supplier
  // matching, names, filter flags — formerly a Google Sheet) and the manual values of the
  // products of a webshop category (list or grid). options.tab: 'matching' (default) | 'category' | 'grid';
  // options.query: the tab's state from the URL (see setState).
  var parseQuery = function (query) {
    var state = {};
    _.each((query || '').replace(/^\?/, '').split('&'), function (pair) {
      if (!pair)
        return;
      var i = pair.indexOf('=');
      var key = decodeURIComponent(i < 0 ? pair : pair.substring(0, i));
      state[key] = i < 0 ? '1' : decodeURIComponent(pair.substring(i + 1).replace(/\+/g, ' '));
    });
    return state;
  };

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'webshop-attributes-view',

    regions: {
      contentRegion: '.content-region'
    },

    events: {
      'click .tab': 'onTab'
    },

    initialize: function () {
      this.tab = _.contains(['category', 'grid', 'filters'], this.options.tab) ? this.options.tab : 'matching';
      this.meta = {languages: ['en', 'fr', 'nl', 'de'], suppliers: []};
      this.state = parseQuery(this.options.query);
    },

    serializeData: function () {
      return {tab: this.tab};
    },

    onShow: function () {
      MatchingApi.meta().done(_.bind(function (meta) {
        this.meta.languages = meta.languages || this.meta.languages;
        this.meta.suppliers = meta.suppliers || [];
        if (!this.isDestroyed)
          this.showTab();
      }, this)).fail(_.bind(function (message) {
        AlertView.prototype.open('', message);
        if (!this.isDestroyed)
          this.showTab();
      }, this));
    },

    showTab: function () {
      this.$('.tab').removeClass('active');
      this.$('.tab[data-tab="' + this.tab + '"]').addClass('active');
      var View = {category: CategoryView, grid: GridView, filters: CategoryFiltersView}[this.tab] || MatchingView;
      this.getRegion('contentRegion').show(new View({
        meta: this.meta,
        state: _.clone(this.state),
        onState: _.bind(this.setState, this)
      }));
    },

    // The sub view's state (attribute, category, search...) goes in the URL, so a refresh / a shared
    // link opens the same screen. null / '' / false values are dropped.
    setState: function (changes) {
      _.extend(this.state, changes);
      // ('underscore' is lodash.underscore: its _.pick takes no predicate)
      _.each(_.keys(this.state), function (k) {
        var v = this.state[k];
        if (v === null || v === undefined || v === '' || v === false)
          delete this.state[k];
      }, this);
      this.navigate(true);
    },

    navigate: function (replace) {
      var query = _.map(this.state, function (v, k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(v === true ? '1' : v);
      }).join('&');
      App.navigate('webshop/attributes' + (this.tab === 'matching' ? '' : '/' + this.tab) + (query ? '?' + query : ''),
        {trigger: false, replace: !!replace});
    },

    onTab: function (e) {
      var tab = $(e.currentTarget).data('tab');
      if (tab === this.tab)
        return;
      var previous = this.tab;
      this.tab = tab;
      // The category is common to the two category screens; the rest belongs to each tab.
      this.state = (previous !== 'matching' && tab !== 'matching') ? _.pick(this.state, 'cat', 'catCode', 'sub') : {};
      this.navigate(false);
      this.showTab();
    }
  });
});

